import React, { useContext, useEffect, useState } from "react";
import { Toaster } from "react-hot-toast";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ajaxCallStation from "../../../util/remote/ajaxCallStation";
import AppContainer from "../../../Components/Structure/AppContainer";
import { Link } from "react-router-dom";
import MessagesFilterForm from "../../../Components/Common/Statistics/MessagesFilterForm";
import useStateCallback from "../../../util/customHooks/useStateCallback";
import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";
import Row from "react-bootstrap/Row";
import Tab from "react-bootstrap/Tab";
import CallContext from "../../../Context/CallContext";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
function MessageStatisticsPage() {

  const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
  const todayFormatted = new Date().toLocaleDateString('en-US', options);
  const [messageStatsOverall, setMessageStatsOverall] = useState(false);
  const [messageStatsToday, setMessageStatsToday] = useState(false);
  const [modal, setModal] = useStateCallback(false);
  const [filteredStats, setFilteredStats] = useState(null);
  const [filterRange, setFilterRange] = useState(null);
  const {messageHighlights} = useContext(CallContext);
  const statsData = filteredStats || messageStatsOverall;
  const editedBusiestHour = messageHighlights.busiest_chat_hour?.hour > 12 ? `${messageHighlights.busiest_chat_hour?.hour - 12}pm` : `${messageHighlights.busiest_chat_hour?.hour}am`;
  const [loadingPage, setLoadingPage] = useState(true);
  
  // useEffect(() => {
  //     getMessageStatsOverall();
  //     getMessageStatsToday();

  // }, []);

  useEffect(() => {
        const fetchAll = async () => {
          setLoadingPage(true);
          await Promise.all([
            getMessageStatsOverall(),
            getMessageStatsToday(),
          ]);
          setLoadingPage(false);
        };
      fetchAll();
      }, []);

  const getMessageStatsOverall = async () => {
    const server_response = await ajaxCallStation.messageStatisticsOverall();
    if (server_response.status === "OK") {
      setMessageStatsOverall(server_response.details);
    } else {
      setMessageStatsOverall(false);
    }
  };

  const getMessageStatsToday = async () => {
    const server_response = await ajaxCallStation.messageStatisticsToday();
    if (server_response.status === "OK") {
      setMessageStatsToday(server_response.details);
    } else {
      setMessageStatsToday(false);
    }
  };

  const filterStats = (e, item) => {
    setModal(false, () => setModal(<MessagesFilterForm g={(data, range) => {
        setFilteredStats(data);
        setFilterRange(range);
      }} isOpen={true}/>));
  };

  const resetFilter = (e) => {
    e.preventDefault();
    setFilteredStats(null);
    setFilterRange(null);
    
  };


  return (
    <AppContainer title="Message Statistics">
        {modal}
      <Toaster position="top-center" reverseOrder={false} />
      {loadingPage ? (
                          // Full page skeleton loader
                          <div style={{ padding: 40 }}>
                            <Skeleton height={40} width={300} style={{ marginBottom: 20 }} />
                            <Skeleton height={200} style={{ marginBottom: 20 }} />
                            <Skeleton count={5} height={30} style={{ marginBottom: 10 }} />
                          </div>
                        ) : (<>
      <div className="row logtat">
            <div className="col-lg-12" style={{padding:0}}>
              <div className="card custom-card" style={{paddingBottom:"10px"}}>
                <div className="card-body map-card gradient-my-blue">
                  <div className="item-title mb-2" style={{color:"white"}}><b>STATISTICS </b></div>
                  <div className="row">
                    
                    <div className="col-xl-2 col-lg-12 col-sm-6 pr-0 pl-0 border-right">
                      <div className="text-center">
                        <h2 className="mb-1 number-font" style={{color:"white"}}><span className="counter">{messageStatsOverall?messageStatsOverall.totals.buzz_text_count.total_p:"..."}</span></h2>
                        <p className="mb-0 text-light"> Buzz Chats</p>
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-12 col-sm-6 pr-0 pl-0 border-right">
                      <div className="text-center">
                        <h2 className="mb-1 number-font" style={{color:"white"}}><span className="counter">{messageStatsOverall?messageStatsOverall.totals.buzz_voice_count.total_p:"..."}</span></h2>
                        <p className="mb-0 text-light"> Buzz Voice Notes</p>
                      </div>
                    </div>
                    <div className="col-xl-2 col-lg-12 col-sm-6 pr-0 pl-0 border-right">
                      <div className="text-center">
                        <h2 className="mb-1 number-font" style={{color:"white"}}><span className="counter">{messageStatsOverall?messageStatsOverall.totals.direct_message_count.total_p:"..."}</span></h2>
                        <p className="mb-0 text-light"> Direct Messages</p>
                      </div>
                    </div>
                    <div className="col-xl-2 col-lg-12 col-sm-6 pr-0 pl-0 border-right">
                      <div className="text-center">
                        <h2 className="mb-1 number-font" style={{color:"white"}}><span className="counter">{messageStatsOverall?messageStatsOverall.totals.buzztime_count.total_p:"..."}</span></h2>
                        <p className="mb-0 text-light"> Buzztime Requests</p>
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-12 col-sm-6 pr-0 pl-0">
                      <div className="text-center">
                        <h2 className="mb-1 number-font" style={{color:"white"}}><span className="counter">{messageStatsOverall?messageStatsOverall.totals.pocket_money_count.total_p:"..."}</span></h2>
                        <p className="mb-0 text-light"> Pocket Money Requests</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>                  
            </div>
          
      </div>
      
      <div className="row">
        <div className="col-lg-6">
              <div className="card custom-card" style={{paddingBottom:"10px"}}>
                <div className="card-body map-card">
                  <div className="item-title">
                    <h5 style={{marginBottom:10}}>Statistics Today ({todayFormatted})</h5>
                  </div>
                  <div className="table-responsive">
                  <table className="table display data-table text-nowrap">
                    <tbody>
                    <tr>
                        <th>Message Type</th>
                        
                        <OverlayTrigger placement="top" overlay={
                          <Tooltip id="refresh-tooltip">Completed</Tooltip>}>
                            <td ><i className="fa fa-square-check" style={{color: "green"}}></i></td></OverlayTrigger>
                        <OverlayTrigger placement="top" overlay={
                          <Tooltip id="refresh-tooltip">Missed</Tooltip>}>
                        <td ><i className="fa fa-square-xmark" style={{color: "#DE3163"}}></i></td></OverlayTrigger>
                        <OverlayTrigger placement="top" overlay={
                          <Tooltip id="refresh-tooltip">Total</Tooltip>}>
                        <th ><i className="fa fa-equals" ></i></th></OverlayTrigger>
                        <OverlayTrigger placement="top" overlay={
                          <Tooltip id="refresh-tooltip">Cash Amount</Tooltip>}>
                        <th ><i className="fa fa-sack-dollar" style={{color: "black"}}></i></th></OverlayTrigger>
                      </tr>
                    
                      <tr>
                        <td>Buzz Chats</td>
                        <td >{messageStatsToday?messageStatsToday.totals.buzz_text_count.total_p:"..."}</td>
                        <td >00</td>
                        <td >{messageStatsToday?messageStatsToday.totals.buzz_text_count.total_p:"..."}</td>
                        <td> UGX. {messageStatsToday? messageStatsToday.totals.buzz_text_cost.total_p:"..."}</td>
                      </tr>
                      <tr>
                        <td>Buzz Voice Notes</td>
                        <td >{messageStatsToday?messageStatsToday.totals.buzz_voice_count.total_p:"..."}</td>
                        <td >00</td>
                        <td >{messageStatsToday?messageStatsToday.totals.buzz_voice_count.total_p:"..."}</td>
                        <td> UGX. {messageStatsToday? messageStatsToday.totals.buzz_voice_cost.total_p:"..."}</td>
                      </tr>
                      <tr>
                        <td>Direct Messages</td>
                        <td >{messageStatsToday?messageStatsToday.totals.direct_message_count.total_p:"..."}</td>
                        <td >00</td>
                        <td >{messageStatsToday?messageStatsToday.totals.direct_message_count.total_p:"..."}</td>
                        <td> UGX. {messageStatsToday? messageStatsToday.totals.direct_message_cost.total_p:"..."}</td>
                      </tr>
                      <tr>
                        <td>Buzz Time Requests</td>
                        <td >{messageStatsToday?messageStatsToday.totals.buzz_time_count.total_p:"..."}</td>
                        <td >00</td>
                        <td >{messageStatsToday?messageStatsToday.totals.buzz_time_count.total_p:"..."}</td>
                        <td> UGX. {messageStatsToday? messageStatsToday.totals.buzz_time_cost.total_p:"..."}</td>
                      </tr>
                      <tr>
                        <td>Pocket Money Requests</td>
                        <td >{messageStatsToday?messageStatsToday.totals.pocket_money_count.total_p:"..."}</td>
                        <td >00</td>
                        <td >{messageStatsToday?messageStatsToday.totals.pocket_money_count.total_p:"..."}</td>
                        <td> UGX. {messageStatsToday? messageStatsToday.totals.pocket_money_cost.total_p:"..."}</td>
                      </tr>
                      
                    </tbody>
                  </table></div>
                </div>
              </div>
           
           
          
        </div>
        <div className="col-lg-6">
              <div className="card custom-card" style={{paddingBottom:"10px"}}>
                <div className="card-body">
                   <div class="heading-layout1 mg-b-5">
                   <div className="item-title">
                    <h5 style={{marginBottom:10}}>Overall Message Statistics {filterRange && (
    <span style={{ fontSize: "0.9rem", color: "#888" }}>
      ({filterRange.startDate} to {filterRange.endDate})
    </span>
  )}</h5>
                  </div>
        <div class="dropdown">
            
          
          <Link class="" onClick={resetFilter} role="button"><i class="fas fa-redo-alt ml-3"></i></Link>
          <Link class="" onClick={filterStats} role="button"><i class="fas fa-filter ml-3"></i></Link>

          {/* <Link class="" onClick={exportToPDF} role="button"><i class="fas fa-download ml-3"></i></Link> */}

        </div>
      </div>
                  <div className="table-responsive">
                  <table className="table display data-table text-nowrap">
                    <tbody>
                    <tr>
                        <th>Message Type</th>
                        
                        <OverlayTrigger placement="top" overlay={
                          <Tooltip id="refresh-tooltip">Completed</Tooltip>}>
                            <td ><i className="fa fa-square-check" style={{color: "green"}}></i></td></OverlayTrigger>
                        <OverlayTrigger placement="top" overlay={
                          <Tooltip id="refresh-tooltip">Missed</Tooltip>}>
                        <td ><i className="fa fa-square-xmark" style={{color: "#DE3163"}}></i></td></OverlayTrigger>
                        <OverlayTrigger placement="top" overlay={
                          <Tooltip id="refresh-tooltip">Total</Tooltip>}>
                        <th ><i className="fa fa-equals" ></i></th></OverlayTrigger>
                        <OverlayTrigger placement="top" overlay={
                          <Tooltip id="refresh-tooltip">Cash Amount</Tooltip>}>
                        <th ><i className="fa fa-sack-dollar" style={{color: "black"}}></i></th></OverlayTrigger>
                      </tr>
                      
                      <tr>
                        <td>Buzz Chats</td>
                        <td >{statsData ? statsData.totals.buzz_text_count.total_p : "..."}</td>
                        <td >00</td>
                        <td >{statsData?statsData.totals.buzz_text_count.total_p:"..."}</td>
                        <td> UGX. {statsData? statsData.totals.buzz_text_cost.total_p:"..."}</td>
                      </tr>
                      <tr>
                        <td>Buzz Voice Notes</td>
                        <td >{statsData?statsData.totals.buzz_voice_count.total_p:"..."}</td>
                        <td >00</td>
                        <td >{statsData?statsData.totals.buzz_voice_count.total_p:"..."}</td>
                        <td> UGX. {statsData? statsData.totals.buzz_voice_cost.total_p:"..."}</td>
                      </tr>
                      <tr>
                        <td>Direct Messages</td>
                        <td >{statsData?statsData.totals.direct_message_count.total_p:"..."}</td>
                        <td >00</td>
                        <td >{statsData?statsData.totals.direct_message_count.total_p:"..."}</td>
                        <td> UGX. {statsData? statsData.totals.direct_message_cost.total_p:"..."}</td>
                      </tr>
                      <tr>
                        <td>Buzz Time Requests</td>
                        <td >{statsData?statsData.totals.buzztime_count.total_p:"..."}</td>
                        <td >00</td>
                        <td >{statsData?statsData.totals.buzztime_count.total_p:"..."}</td>
                        <td> UGX. {statsData? statsData.totals.buzztime_cost.total_p:"..."}</td>
                      </tr>
                      <tr>
                        <td>Pocket Money Requests</td>
                        <td >{statsData?statsData.totals.pocket_money_count.total_p:"..."}</td>
                        <td >00</td>
                        <td >{statsData?statsData.totals.pocket_money_count.total_p:"..."}</td>
                        <td> UGX. {statsData? statsData.totals.pocket_money_cost.total_p:"..."}</td>
                      </tr>
                    </tbody>
                  </table></div>
                </div>
              </div>
            
           
         
         
        </div>
      </div>

      <div className="row">
      <div className="col-lg-12 col-md-12 mt-3">
              <div className="card height-auto">
                <div className="card-body">
                  <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                    <Row>
                      <Col sm={12}>
                        <Nav variant="pills" className="flex-row mb-1">
                          
                          <Nav.Item>
                            <Nav.Link size="sm" eventKey="first">
                              Message Highlights{" "}
                            </Nav.Link>
                          </Nav.Item>
                          
                        </Nav>
                      </Col>
                      <Col sm={12}>
                        <Tab.Content>
                          
                          <Tab.Pane eventKey="first">
                           <div className="row">
                            <div className="col-xl-6 col-lg-12 col-sm-6 pr-0 pl-0 border-right">
                              <div className="text-center" style={{marginTop: "10px"}}>
                                <h3 className="mb-1 number-font" style={{color:"#042954"}}><i className="fe fe-message-square mr-1"></i> <span className="counter">Message Lengths</span></h3>
                              </div>
                              <div className="row">
                                <div className="col-xl-6 col-lg-12 col-sm-6 pr-0 pl-0 border-right">
                                  <div className="text-center">
                                    <h5 className="mb-1 number-font"><span className="counter">{messageHighlights? messageHighlights.average_chat_length?.total_p:"..."} characters</span></h5>
                                    <p className="mb-2 text-dark"> Average Buzz Chat</p>
                                  </div>
                                </div>
                                <div className="col-xl-6 col-lg-12 col-sm-6 pr-0 pl-0">
                                  <div className="text-center">
                                    <h5 className="mb-1 number-font"><span className="counter">{messageHighlights? messageHighlights.average_dm_length?.total_p:"..."} characters</span></h5>
                                    <p className="mb-2 text-dark"> Average Direct Message</p>
                                  </div>
                                </div>
                               
                                 
                              </div>
                              
                              <div className="text-center" style={{marginTop: "10px"}}>
                                <h3 className="mb-1 number-font" style={{color:"#042954"}}><i className="fe fe-user mr-1"></i><span className="counter">Top Senders</span></h3>
                              </div>
                              <div className="row">
                                <div className="col-xl-6 col-lg-12 col-sm-6 pr-0 pl-0 border-right">
                                  <div className="text-center">
                                    <h5 className="mb-1 number-font"><span className="counter">{messageHighlights? messageHighlights.top_buzz_chat_sender?.sender_name:"..."}</span></h5>
                                    <p className="mb-2 text-dark"> {messageHighlights? messageHighlights.top_buzz_chat_sender?.message_count?.total_c:"..."} Buzz Chats</p>
                                  </div>
                                </div>
                                <div className="col-xl-6 col-lg-12 col-sm-6 pr-0 pl-0">
                                  <div className="text-center">
                                    <h5 className="mb-1 number-font"><span className="counter">{messageHighlights? messageHighlights.top_buzz_audio_sender?.sender_name:"..."}</span></h5>
                                    <p className="mb-2 text-dark"> {messageHighlights? messageHighlights.top_buzz_audio_sender?.message_count?.total_c:"..."} Buzz Voice Notes</p>
                                  </div>
                                </div>
                                 <div className="col-xl-6 col-lg-12 col-sm-6 pr-0 pl-0 border-right">
                                  <div className="text-center">
                                    <h5 className="mb-1 number-font"><span className="counter">{messageHighlights? messageHighlights.top_buzz_time_sender?.sender_name:"..."}</span></h5>
                                    <p className="mb-2 text-dark">{messageHighlights? messageHighlights.top_buzz_time_sender?.message_count?.total_c:"..."} Buzztime Requests</p>
                                  </div>
                                </div>
                                <div className="col-xl-6 col-lg-12 col-sm-6 pr-0 pl-0">
                                  <div className="text-center">
                                    <h5 className="mb-1 number-font"><span className="counter">{messageHighlights? messageHighlights.top_pocket_money_sender?.sender_name:"..."}</span></h5>
                                    <p className="mb-2 text-dark"> {messageHighlights? messageHighlights.top_pocket_money_sender?.message_count?.total_c:"..."} Pocket money Requests</p>
                                  </div>
                                </div>
                                <div className="col-xl-6 col-lg-12 col-sm-6 pr-0 pl-0 border-right">
                                  <div className="text-center">
                                    <h5 className="mb-1 number-font"><span className="counter">{messageHighlights? messageHighlights.top_direct_message_sender?.sender_name:"..."}</span></h5>
                                    <p className="mb-2 text-dark">{messageHighlights? messageHighlights.top_direct_message_sender?.message_count?.total_c:"..."} Direct Messages</p>
                                  </div>
                                </div>
                                <div className="col-xl-6 col-lg-12 col-sm-6 pr-0 pl-0">
                                  <div className="text-center">
                                    <h5 className="mb-1 number-font"><span className="counter">{messageHighlights? messageHighlights.top_support_user?.sender_name:"..."}</span></h5>
                                    <p className="mb-2 text-dark"> {messageHighlights? messageHighlights.top_support_user?.message_count?.total_c:"..."} Support Requests</p>
                                  </div>
                                </div>
                                 
                              </div>


                            </div>
                            <div className="col-xl-6 col-lg-12 col-sm-6 pr-0 pl-0">
                              <div className="text-center" style={{marginTop: "10px"}}>
                                <h3 className="mb-1 number-font" style={{color:"#042954"}}><i className="fe fe-calendar mr-1"></i><span className="counter">Message Peaks</span></h3>
                              </div>
                              <div className="row">
                                <div className="col-xl-12 col-lg-12 col-sm-6 pr-0 pl-0">
                                  <div className="text-center">
                                    <h5 className="mb-1 number-font"><span className="counter">{messageHighlights? messageHighlights.most_chats_day?.date?.short_date:"..."}</span></h5>
                                    <p className="mb-2 text-dark"> {messageHighlights? messageHighlights.most_chats_day?.total_chats?.total_c:"..."} Buzz Chats</p>
                                  </div>
                                </div>
                                <div className="col-xl-12 col-lg-12 col-sm-6 pr-0 pl-0">
                                  <div className="text-center">
                                    <h5 className="mb-1 number-font"><span className="counter">{messageHighlights? messageHighlights.most_dms_day?.date?.short_date:"..."}</span></h5>
                                    <p className="mb-2 text-dark"> {messageHighlights? messageHighlights.most_dms_day?.total_dms?.total_c:"..."} Direct Messages</p>
                                  </div>
                                </div>
                                 
                                 
                              </div>
                              <div className="text-center" style={{marginTop: "10px"}}>
                                <h3 className="mb-1 number-font" style={{color:"#042954"}}><i className="fe fe-trending-up mr-1"></i><span className="counter">Engagement Metrics</span></h3>
                              </div>
                              <div className="row">
                                <div className="col-xl-6 col-lg-12 col-sm-6 pr-0 pl-0 border-right mb-2">
                                  <div className="text-center">
                                    <h5 className="mb-1 number-font"><span className="counter">{messageHighlights? messageHighlights.buzz_chat_usage_rate: "..."}</span></h5>
                                    <p className="mb-0 text-dark"> Buzz Chats Usage Rate</p>
                                    <p className="mb-2 text-dark"> {messageHighlights? messageHighlights.buzz_chatters?.total_c : "..."} Students</p>
                                  </div>
                                </div>
                                <div className="col-xl-6 col-lg-12 col-sm-6 pr-0 pl-0 mb-2">
                                  <div className="text-center">
                                    <h5 className="mb-1 number-font"><span className="counter">{messageHighlights? editedBusiestHour: "..."}</span></h5>
                                    <p className="mb-0 text-dark"> Busiest Hour</p>
                                    <p className="mb-2 text-dark"> {messageHighlights? messageHighlights.busiest_chat_hour?.chat_count?.total_c : "..."} Buzz Chats</p>
                                  </div>
                                </div>
                                <div className="col-xl-6 col-lg-12 col-sm-6 pr-0 pl-0 border-right mb-2">
                                  <div className="text-center">
                                    <h5 className="mb-1 number-font"><span className="counter">{messageHighlights? messageHighlights.chat_streak_leader?.sender_name : "..."}</span></h5>
                                    <p className="mb-0 text-dark"> Consistent Chatter</p>
                                    <p className="mb-2 text-dark"> {messageHighlights? messageHighlights.chat_streak_leader?.message_count?.total_p: "..."}-Day Streak</p>
                                  </div>
                                </div>
                                
                                
                                
                                 
                                 
                              </div>


                            </div>
                    
                    
                    
                    
                          </div> 
                  
                          </Tab.Pane>
                        </Tab.Content>
                      </Col>
                    </Row>
                  </Tab.Container>  
                </div>
              </div>
          </div>
      </div></>)}
     
    </AppContainer>
  );
}

export default MessageStatisticsPage;
